export default __webpack_public_path__ + "static/media/10.3a979217.jpg";